import GitHub from '../Assets/Images/social/github.svg';
import LinkedIn from '../Assets/Images/social/linkedin.svg';
import CodePen from '../Assets/Images/social/codepen.svg';
import FrontendMentor from '../Assets/Images/social/frontend-mentor.svg';
import Medium from '../Assets/Images/social/medium.svg';

export const SOCIAL = [
	{
		name: 'Link to GitHub profile',
		link: 'https://github.com/paladinescamila',
		img: GitHub,
	},
	{
		name: 'Link to LinkedIn profile',
		link: 'https://www.linkedin.com/in/paladinescamila',
		img: LinkedIn,
	},
	{
		name: 'Link to CodePen profile',
		link: 'https://codepen.io/paladinescamila',
		img: CodePen,
	},
	{
		name: 'Link to Frontend Mentor profile',
		link: 'https://www.frontendmentor.io/profile/paladinescamila',
		img: FrontendMentor,
	},
	{
		name: 'Link to Medium profile',
		link: 'https://medium.com/@paladinescamila',
		img: Medium,
	},
];
